import axios from "axios";
import {materialCloudServicesPath} from "../../../Constants";

const jobRestUrl =materialCloudServicesPath + '/user/job-metric-packing-material'

export default class JobMetricPacking {

    static async getJobMetricPackingByMaterialId(materialId) {
        return axios.get(jobRestUrl + '/by-material-id-for-catalog'
            + '?materialId=' + materialId);
    }
}